export const REAL_DONALD_TRUMP = 'realDonaldTrump';